import type { IntlShape } from 'react-intl';

import { getProfileCardActions } from '@atlassian/bitbucket-user-profile';

import { atlassianAccountProfileClient } from '../../../utils/profile-client';
import { uncurlyAaid } from '../../../utils/uncurly-aaid';

export const buildProfilecardProvider = (config: { intl: IntlShape }) =>
  Promise.resolve({
    // Our profile client does not use this value yet, but it's required
    cloudId: 'null',
    getActions: (id: string) => {
      const aaid = uncurlyAaid(id) || id;
      return getProfileCardActions({
        intl: config.intl,
        profileUrl: `/${aaid}`,
      });
    },
    resourceClient: atlassianAccountProfileClient,
  });
